import React, { useState, useCallback, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { getApiTeamSlackQaChannelsUrl, getTeamSlackQaChannelsUrl } from '../../utilities/urlHelper';
import SlackConversationSelector from '../SlackConversationSelector';

const AddSlackQAChannelsModal = () => {
    const [showModal, setShowModal] = useState(false);
    const [selectedChannelIds, setSelectedChannelIds] = useState([]);
    let isFetchingChannels = false;

    const onClick = useCallback((e) => {
        e.preventDefault();
        setShowModal(true);
    }, []);

    const onMouseDown = useCallback(({ target }) => {
        const className = target.getAttribute('class');
        if (className && className.includes('react-modal open')) {
            setShowModal(false);
        }
    }, []);

    const getSelectedChannelIds = () => {
        if (isFetchingChannels) return;
        isFetchingChannels = true;
        const url = getApiTeamSlackQaChannelsUrl(window.teamId);
        $.get(url, { _token: window.csrfToken })
            .then(({ channelIds }) => {
                setSelectedChannelIds(channelIds);
            })
            .catch(console.error)
            .always(() => {
                isFetchingChannels = false;
            });
    };

    useEffect(() => {
        if (!showModal) return;
        getSelectedChannelIds();
    }, [showModal]);

    useEffect(() => {
        document.querySelector('[data-trigger-select-slack-qa-channels]')?.addEventListener('click', onClick);
        return () => document.querySelector('[data-trigger-select-slack-qa-channels]')?.removeEventListener('click', onClick);
    }, []);

    return showModal && createPortal(
        <div className="react-modal open" onMouseDown={onMouseDown}>
            <div className="modal-content p2">
                <h2>Select Slack channels</h2>
                <form action={getTeamSlackQaChannelsUrl(window.teamId)} method="post">
                    <input name="_token" type="hidden" value={window.csrfToken} />
                    <input name="_method" type="hidden" value="post" />
                    <div className="mb2">
                        {isFetchingChannels
                            ? <span className="gray loading">Loading selected channels...</span>
                            : (
                                <SlackConversationSelector
                                    initialConversationIds={selectedChannelIds}
                                    isMulti
                                />
                            )}
                    </div>
                    <div className="right-align">
                        <button type="button" className="btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
                        <button type="submit" className="btn btn-primary ml1">Update channels</button>
                    </div>
                </form>
            </div>
        </div>,
        document.body,
    );
};

export default AddSlackQAChannelsModal;
